var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:'xm-button ' +
  ' xm-button-' + _vm.type + 
  ' xm-button-' + _vm.size +
  (_vm.round ? ' xm-button-round' : '') +
  (_vm.bordered ? ' xm-button-bordered' : '') +
  (_vm.active ? ' active' : '') +
  (_vm.disabled ? ' disabled' : ''),on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1bab8b8f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Button.vue
// module id = 1384
// module chunks = 191